<template>
  <div id="login-change">
    <div class="dropdown" v-if="isLoggedIn">
      <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
        <span class="d-none d-sm-inline pl-2 small">{{ $translate("Ceres::Template.myAccount") }}</span>
      </a>
      <div class="account-menu dropdown-menu dropdown-menu-right small border-0 m-0 p-0">
        <div class="list-group" aria-labelledby="accountMenuList">
          <a :href="$ceres.urls.myAccount" class="list-group-item small">
            <i class="fa fa-user-circle-o"></i>
            {{ $translate("Ceres::Template.loginMyAccount") }}
          </a>
          <a href="#" class="list-group-item small" v-logout>
            <i class="fa fa-sign-out"></i>
            {{ $translate("Ceres::Template.loginLogout") }}
          </a>
        </div>
      </div>
    </div>
    <div v-if="!isLoggedIn">
      <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
        <i class="fa fa-user-circle-o" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" :title="$translate('Ceres::Template.login')"></i>
        <span class="d-none d-sm-inline pl-2 small">{{ $translate("Ceres::Template.login") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import ValidationService from "../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        } 
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
